export const DEMO_STORE = {
    "model": {
        "version": 2.2,
        "activeDashboardId": 5850447135244288,
        "authUser": {
            "timezone": "Asia/Yerevan",
            "logo": "//domainlogo.kanbanchi.com/kanbanchi.com",
            "id": "109904642684951714227",
            "platformType": "google",
            "firstName": "Demo",
            "lastName": "Kanbanchi",
            "fullName": "Demo Kanbanchi",
            "initials": "AP",
            "email": "demo@kanbanchi.com",
            "hash": "25094d37ca0c457e8a2414a115afc644",
            "notificationEmail": "demo@kanbanchi.com",
            "anonym": false,
            "admin": true,
            "token": {},
            "tokenHash": "",
            "needLogin": false,
            "ipChanged": false,
            "tryRememberMe": true,
            "isEmailChanged": false,
            "firstVisit": false,
            "region": "eng",
            "country": "GB",
            "createDate": "20220215",
            "firstTrialCode": "",
            "secondTrialCode": "0J0pA1141",
            "createDateTimeStamp": 1644883200,
            "createDateTimeStampSec": 1644920495,
            "city": "london",
            "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar1.png",
            "allowTimeTracker": true,
            "allowBranding": true,
            "allowBoardTemplate": true,
            "allowGantt": true,
            "allowListView": true,
            "allowChecklistCount": 100,
            "allowChecklistItemCount": 100,
            "allowColorTagCount": 100,
            "allowCardColorCount": 1000,
            "allowSubCardCount": 1000,
            "allowCardTagCount": 100,
            "allowChatSupport": false,
            "allowCardFromEmail": true,
            "allowCardCustomProperties": true,
            "allowGoogleSheetExport": true,
            "allowPriorityAutoSorting": true,
            "allowDashboardBackground": true,
            "allowBackupXml": true,
            "allowAutoBackupXml": true,
            "allowCardsAssignedToMe": true,
            "allowSubCard": true,
            "allowActivity": true,
            "allowCardAgeing": true,
            "allowCardNumber": true,
            "allowPublicFilter": true,
            "allowAssigneesRoles": true,
            "allowSavedFilters": true,
            "allowStatusMapping": true,
            "allowAttacheTeamDriveFile": true,
            "allowArchive": true,
            "allowReports": false,
            "allowRoles": true,
            "allowNotificationBeforeDueDates": true,
            "allowSharedDrive": true,
            "allowTeamWorkload": true,
            "allowCreateBoard": true,
            "allowDeleteBoard": true,
            "allowFreeVersion": false,
            "allowRecurringTask": false, //DEMO
            "allowRequiredProperties": true,
            "allowSwimlanes": true,
            "allowDependencies": true,
            "allowTimeTrackerExport": true,
            "allowMyWorkCustomFilters": true,
            "allowMyWorkTaskGrouping": true,
            "permissionId": "17094646725275218694",
            "allowedCookies": "[\"performance\"]",
            "segmentAlias": false,
            "affiliateId": "25094d37ca0c457e8a2414a115afc644",
            "domainWideEnterprise": false,
            "domainWidePremium": false,
            "domainWideProfessional": false,
            "domainWideEssential": false,
            "domainWideEndDate": 0,
            "accountType": 2,
            "markAllReadLastDate": -1706770865331,
            "refreshTokenExeption": false,
            "testMode": false,
            "cometToken": "",
            "cometTokenToSystemRoom": "",
            "inWorkCardId": 0,
            "oAuthScopes": [
                "https://www.googleapis.com/auth/calendar",
                "https://www.googleapis.com/auth/drive.file",
                "https://www.googleapis.com/auth/drive.install",
                "https://www.googleapis.com/auth/drive.readonly",
                "https://www.googleapis.com/auth/userinfo.email",
                "https://www.googleapis.com/auth/userinfo.profile",
                "openid"
            ],
            "activeSubscription": [

            ],
            "ownSubscription": [],
            "managedSubscription": [],
            "products": [],
            "settings": {
                "commentSort": -1
            },
            "meta": {
                "lastLogin": "20250602",
                "dayInSystem": "488",
                "landingPage": "https://kanban-chi.appspot.com/",
                "refferal": "https://www.google.com/",
                "qualificationForm": {
                    "status": "SKIPPED"
                },
                "recentBoards": [
                    {
                        "id": 5719466544594944,
                        "name": "Demo board",
                        "logoColor": "#dbd3fd",
                        "logoIcon": "start-date"
                    }
                ],
                "newCardsCount": 21,
                "lastUpdateShownTime": 1674691200000,
                "freeVersionAfterFirstTrial": true,
                "haveSharedBoardWith2Other": true,
                "noGanttUsageSent": true,
                "featuresSeen": [
                    "TOPBAR_REDESIGN_TIPS",
                    "TOPBAR_REDESIGN",
                    "TOPBAR_REDESIGN_TIPS_SEEN",
                    "MY_WORK",
                    "PASTE_ATTACHMENT",
                    "LOGIN_SPECIFIC_BOARD",
                    "BOARD_SPLIT_SETTINGS"
                ],
                "isAttachmentViewTypeGrid": true,
                "ganttOpened": true,
                "affiliateDialogShownDate": 1652695874475,
                "isDontShowShareHint": true,
                "abandonedCart": "Starter",
                "isOpenLastBoard": false,
                "rateAppPoll": {
                    "lastTimeShowed": 1670569735378,
                    "isSkipped": true
                },
                "isLifeTimeSpentSentTime": 1681994429217,
                "defaultView": "KanbanDashboard",
                "rateFeaturePoll": {
                    "skipDate": 1709276518332,
                    "triggeredFeatureId": 8
                },
                "isShowChecklistItemsAuthor": false,
                "sortedSavedFiltersIds": {
                    "-1": [
                        4995927731994624,
                        4544555073011712,
                        4931538605703168,
                        5775049378889728,
                        6338995093635072,
                        4600914573393920
                    ],
                    "5719466544594944": [
                        1748945211358,
                        1748945091143
                    ]
                },
                "myWork": {
                    "isHideMoreBoardsSnackbar": true,
                    "enabledFilters": [],
                    "unselectedBoards": [],
                    "selectedBoards": [],
                    "groupBy": "Board",
                    "boardsUpdatesLastSeen": 1709020598509
                },
                "recentAccordion": "RECENT",
                "defaultAttachmentType": "DRIVE",
                "isHideDoneChecklistItems": false,
                "pricingPoll": {
                    "isTriggered": true,
                    "isSkipped": false,
                    "lastTimeShowed": 0
                },
                "isOpenCardOnCreateSnackbarShowed": true,
                "isOpenCardOnCreate": true,
                "isCommentsColumnView": false
            },
            "availableChargeBeeCoupons": [],
            "domainInfo": {
                "industry": "COMPUTER_SOFTWARE",
                "employeeCount": "10"
            },
            "hasAssignedCards": true,
            "eduV2": false,
            "userHaveDeletionTask": false,
            "isDeletedByCron": false,
            "usersInDomainCount": 51,
            "supportExport": true,
            "supportCalendarPush": true,
            "supportBackup": true,
            "supportBranding": true,
            "supportBoardArchive": true,
            "supportStarred": true,
            "supportSharedDrive": true,
            "appFolderInfo": {
                "folderId": "1XuVd5zKQKnEjHeHOoQwHG0XbiIKZGBIZ"
            },
            "logoX": 0,
            "unseenNotificationCount": 5,
            "collaboratorColor": "hsl(344, 75%, 34%)"
        },
        "cards": {
            "4606990710341632": {
                "colorIds": [],
                "orderNumber": 0,
                "ganttOrderNumber": 131072,
                "listViewOrderNumber": 1749183228,
                "created": 1749183228,
                "description": "",
                "assignedToDetails": [],
                "assignees": [],
                "startDate": 1749434411,
                "doneDate": 1749183234,
                "dueDate": 1749553246,
                "tags": [
                    "Explore"
                ],
                "processingStatus": "done",
                "processingPercent": 100,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "priority": "0",
                "recurringTasks": [],
                "ganttVisibility": true,
                "isMilestone": false,
                "lastActivityDateStamp": 1749183705904,
                "name": "Explore the Demo version",
                "listId": 4946132065452032,
                "cardNumber": "",
                "moveInListDate": 1749183228851,
                "id": 4606990710341632,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [
                    {
                        "cardId": 4706068190330880,
                        "type": "FTS",
                        "predecessorId": 4606990710341632,
                        "status": 0,
                        "id": 5228937542500352,
                        "receiveProperty": []
                    }
                ],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "4635528821866496": {
                "colorIds": [
                    5409755632107520,
                    6289029020909568
                ],
                "orderNumber": 65536,
                "listViewOrderNumber": 1749181045,
                "created": 1749181045,
                "description": "**\"My tasks\"** will help you with this. This space shows cards from different boards and allows you to track tasks you've created, assigned, and contributed to.\nA detailed article can be found [here](https://www.kanbanchi.com/faqwd/my-tasks)",
                "assignedToDetails": [],
                "assignees": [],
                "startDate": 1710478812,
                "dueDate": 1728914420,
                "tags": [
                    "Explore"
                ],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749183331165,
                "name": "Where can I find cards from **different boards**?",
                "listId": 5173349257183232,
                "cardNumber": "",
                "moveInListDate": 1749181045705,
                "id": 4635528821866496,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "4636306479382528": {
                "colorIds": [
                    5409755632107520,
                    6289029020909568
                ],
                "orderNumber": 0,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "You may quickly migrate from Atlassian: Trello and Jira.\nAlso, CSV import is possible. \n\n[Review this article](https://www.kanbanchi.com/faqwd/how-can-i-import-data-to-kanbanchi) to easily migrate to Kanbanchi.",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749183330877,
                "name": "Is there a way to **import data** to Kanbanchi?",
                "listId": 5173349257183232,
                "cardNumber": "",
                "moveInListDate": 1749181045072,
                "id": 4636306479382528,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6299249164025856": {
                "colorIds": [
                    5409755632107520,
                    6289029020909568
                ],
                "orderNumber": 131072,
                "listViewOrderNumber": 1749181046,
                "created": 1749181046,
                "description": "Yes, it does. [This article](https://www.kanbanchi.com/faqwd/how-can-i-use-kanbanchi-on-a-mobile-device/) will help you to configure Kanbanchi for mobile usage.\n![Kanbanchi works on mobile devices](https://www.kanbanchi.com/wp-content/uploads/2015/05/1-2.png)",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "meta": {
                    "pinnedSections": {
                        "description": true
                    }
                },
                "lastActivityDateStamp": 1749183331408,
                "name": "Does Kanbanchi work on **mobile devices**?",
                "listId": 5173349257183232,
                "cardNumber": "",
                "moveInListDate": 1749181046372,
                "id": 6299249164025856,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true
            },
            "5985933715701760": {
                "colorIds": [
                    4600179160645632
                ],
                "orderNumber": 65536,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "**Lists** usually represent workflow stages, while **cards** stand for tasks.\nCertainly, you may rethink how board elements can be used depending on your workflow. For instance, you may create a separate list for each client. ",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 6306907542388736,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181045187,
                "name": "Kanbanchi board consists of cards and lists.",
                "listId": 5653237059682304,
                "cardNumber": "",
                "moveInListDate": 1749181045063,
                "id": 5985933715701760,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6081590354903040": {
                "colorIds": [
                    4600179160645632
                ],
                "orderNumber": 131072,
                "listViewOrderNumber": 1749181045,
                "created": 1749181045,
                "description": "However, this structure is not obligatory. You may adjust it according to your needs by renaming them or creating new lists.",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 5758401161330688,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "meta": {
                    "pinnedSections": {
                        "description": true
                    }
                },
                "lastActivityDateStamp": 1749181045838,
                "name": "By default, all boards are created with the three lists: To Do - Doing - Done",
                "listId": 5653237059682304,
                "cardNumber": "",
                "moveInListDate": 1749181045674,
                "id": 6081590354903040,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "openedQuickLook": null
            },
            "6145517654769664": {
                "colorIds": [],
                "backgroundColor": "#EDE9FE",
                "orderNumber": 0,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "fullName": "Friend",
                            "firstName": "Friend",
                            "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar2.png",
                            "permissionId": "04196864541585468061"
                        },
                        "roleIds": []
                    }
                ],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749183370518,
                "name": "**Welcome to Kanbanchi!👋**\n\nThis Demo board will help you explore.                   \n**Click on cards** to open them and find instructions, feature explanations, and valuable advice.",
                "listId": 5653237059682304,
                "cardNumber": "",
                "moveInListDate": 1749181044415,
                "id": 6145517654769664,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6260763572699136": {
                "colorIds": [
                    6289029020909568,
                    5409755632107520
                ],
                "orderNumber": 0,
                "ganttOrderNumber": 196608,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "Click **Sign up** to start your **7-day trial of the Enterprise plan.**\nAfter the trial expires, you can purchase a subscription. Check our [Pricing](https://kanban-chi.appspot.com/dashboard/pricing) to choose the plan and the type of billing. **Note** you may purchase different plans for your team and distribute the seats in the Admin panel.\nNot ready to upgrade yet? You may stay on the free plan.\nConsider [its limitations.](https://www.kanbanchi.com/faqwd/kanbanchi-free-plan)",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "13529517536500880352",
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi",
                            "lastName": "App",
                            "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s64"
                        },
                        "roleIds": []
                    }
                ],
                "startDate": 1751248816,
                "doneDate": 1679566974,
                "tags": [
                    "To do"
                ],
                "processingStatus": "done",
                "processingPercent": 100,
                "commentCount": 0,
                "driveDocCount": 2,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "priority": "4",
                "recurringTasks": [],
                "ganttVisibility": true,
                "isMilestone": true,
                "lastActivityDateStamp": 1749184035576,
                "name": "**Start free trial**                                                Congratulations🎉 You've mastered the demo version. Now it's time to try the real app!\n*Click on this card to learn what will happen after the trial*",
                "listId": 6313432756649984,
                "cardNumber": "",
                "moveInListDate": 1749181045072,
                "id": 6260763572699136,
                "receiveProperty": [],
                "driveDocIds": [
                    5403218322784256,
                    4567940196597760
                ],
                "meta": {},
                "driveDocs": [
                    {
                        "title": "Kanbanchi for Enterprise.pdf",
                        "fileId": "1fmLbRq9kt32nSKvnLzYge3TgUpjRuhcp",
                        "mimeType": "application/pdf",
                        "url": "https://drive.google.com/file/d/1fmLbRq9kt32nSKvnLzYge3TgUpjRuhcp/view?usp=drivesdk",
                        "iconUrl": "https://drive-thirdparty.googleusercontent.com/32/type/application/pdf",
                        "main": false,
                        "orderNumber": 1,
                        "created": 1727351015,
                        "authorDetails": {
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi App",
                            "lastName": "Team",
                            "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                            "initials": "KT",
                            "permissionId": "13529517536500880352",
                            "hash": "e5f254cc1767c6623507723ac069558f"
                        },
                        "isImage": false,
                        "cardId": 6260763572699136,
                        "type": "card",
                        "platformType": "google",
                        "id": 4567940196597760,
                        "receiveProperty": []
                    },
                    {
                        "title": "Kanbanchi plans comparison.pdf",
                        "fileId": "1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                        "mimeType": "application/pdf",
                        "url": "https://drive.google.com/file/d/1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T/view?usp=drivesdk",
                        "iconUrl": "https://drive-thirdparty.googleusercontent.com/32/type/application/pdf",
                        "thumbUrl": "https://drive.google.com/thumbnail?authuser=0&sz=w280&id=1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                        "bigThumbUrl": "https://drive.google.com/thumbnail?authuser=0&sz=w600&id=1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                        "main": true,
                        "orderNumber": 0,
                        "created": 1727349240,
                        "authorDetails": {
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi App",
                            "lastName": "Team",
                            "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                            "initials": "KT",
                            "permissionId": "13529517536500880352",
                            "hash": "e5f254cc1767c6623507723ac069558f"
                        },
                        "isImage": false,
                        "cardId": 6260763572699136,
                        "type": "card",
                        "platformType": "google",
                        "id": 5403218322784256,
                        "receiveProperty": []
                    }
                ],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [
                    {
                        "id": 5403218322784256,
                        "title": "Kanbanchi plans comparison.pdf",
                        "iconUrl": "https://drive-thirdparty.googleusercontent.com/16/type/application/pdf",
                        "fileId": "1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                        "mimeType": "application/pdf",
                        "url": "https://drive.google.com/file/d/1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T/view?usp=drivesdk",
                        "orderNumber": 0,
                        "thumbUrl": "https://drive.google.com/thumbnail?authuser=0&sz=w280&id=1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                        "isImage": false,
                        "cardId": 6260763572699136,
                        "platformType": "google"
                    }
                ],
                "predecessors": [],
                "isFullLoaded": true
            },
            "4541511786430464": {
                "colorIds": [],
                "orderNumber": 65536,
                "listViewOrderNumber": 1749181046,
                "created": 1749181046,
                "description": "Click ![Add new list](https://www.kanbanchi.com/wp-content/uploads/2023/02/add-new-list.jpg) Change the list name to 'Doing.'",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [
                    "To do"
                ],
                "processingPercent": 0,
                "copiedFromId": 6442646326345728,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181046458,
                "name": "Create a new list and name it 'Doing'",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181046313,
                "id": 4541511786430464,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "4556416530907136": {
                "colorIds": [
                    6289029020909568
                ],
                "orderNumber": 262144,
                "ganttOrderNumber": 262144,
                "listViewOrderNumber": 1749181047,
                "created": 1749181047,
                "description": "Great! Let's explore some advanced features. Check out subcards for more!",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "13529517536500880352",
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi",
                            "lastName": "App",
                            "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s64"
                        },
                        "roleIds": []
                    }
                ],
                "dueDate": 1753095600,
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": true,
                "isMilestone": false,
                "lastActivityDateStamp": 1749184079583,
                "name": "**Learn Advanced features**",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181048223,
                "id": 4556416530907136,
                "receiveProperty": [],
                "subCardIds": [
                    5287497181822976,
                    5902303790235648
                ],
                "meta": {},
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [
                    {
                        "cardId": 4556416530907136,
                        "type": "FTS",
                        "predecessorId": 4706068190330880,
                        "status": 0,
                        "id": 5558009682329600,
                        "receiveProperty": []
                    }
                ],
                "isFullLoaded": true
            },
            "4706068190330880": {
                "colorIds": [],
                "orderNumber": 0,
                "listViewOrderNumber": 1749181045,
                "created": 1749181045,
                "description": "Let's start small. Perform three tasks described in the cards below to learn how to create cards, lists, and share boards. Mark them as Done when the task is completed.",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "13529517536500880352",
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi",
                            "lastName": "App",
                            "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s64"
                        },
                        "roleIds": []
                    }
                ],
                "startDate": 1750125628,
                "dueDate": 1750244431,
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": true,
                "isMilestone": false,
                "lastActivityDateStamp": 1749183810884,
                "name": "**Learn Kanbanchi basics**",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181045617,
                "id": 4706068190330880,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [
                    {
                        "cardId": 4556416530907136,
                        "type": "FTS",
                        "predecessorId": 4706068190330880,
                        "status": 0,
                        "id": 5558009682329600,
                        "receiveProperty": []
                    }
                ],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [
                    {
                        "cardId": 4706068190330880,
                        "type": "FTS",
                        "predecessorId": 4606990710341632,
                        "status": 0,
                        "id": 5228937542500352,
                        "receiveProperty": []
                    }
                ],
                "isFullLoaded": true,
                "meta": {}
            },
            "5287497181822976": {
                "colorIds": [
                    6289029020909568
                ],
                "orderNumber": 393216,
                "ganttOrderNumber": 327680,
                "listViewOrderNumber": 1749181049,
                "created": 1749181049,
                "description": "As you may notice, the cards on this board have **colour labels, tags, priority, and colours**. All these features are used for card categorization and prioritization. **List grouping and Swimlanes** group cards by these properties, allowing you to review board data from different angles.\n\nClick **Kanban board** on the switcher to return to this view.  \n![Views](https://www.kanbanchi.com/wp-content/uploads/2023/02/views-kanbanchi.jpg)",
                "assignedToDetails": [],
                "assignees": [],
                "dueDate": 1753095600,
                "tags": [
                    "Explore"
                ],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "epicId": 4556416530907136,
                "subCardOrderNumber": 65536,
                "ganttVisibility": true,
                "isMilestone": false,
                "lastActivityDateStamp": 1749184060351,
                "name": "Explore List Grouping and Swimlanes",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181049529,
                "id": 5287497181822976,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "5902303790235648": {
                "colorIds": [
                    6289029020909568
                ],
                "orderNumber": 327680,
                "ganttOrderNumber": 327680,
                "listViewOrderNumber": 1749181048,
                "created": 1749181048,
                "description": "**The Gantt chart** gives you an oversight with a clear project timeline that helps you organize and monitor tasks effectively.\nSwitch to the Gantt chart to see the cards on the chart. The black arrows are **dependencies** that show the sequence of the tasks. \n\nClick **Kanban board** on the switcher to return to this view.\n![Gantt](https://www.kanbanchi.com/wp-content/uploads/2023/02/gantt-chart.jpg)",
                "assignedToDetails": [],
                "assignees": [],
                "dueDate": 1753077636,
                "tags": [
                    "Explore"
                ],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "epicId": 4556416530907136,
                "subCardOrderNumber": 0,
                "ganttVisibility": true,
                "isMilestone": false,
                "lastActivityDateStamp": 1749184079224,
                "name": "Explore the Gantt chart",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181048951,
                "id": 5902303790235648,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6026392441847808": {
                "colorIds": [
                    6289029020909568
                ],
                "orderNumber": 196608,
                "listViewOrderNumber": 1749181047,
                "created": 1749181047,
                "description": "Click ![Share button](https://www.kanbanchi.com/wp-content/uploads/2023/02/share-button.jpg) at the top right corner of the board and type the emails of your colleagues. Click **Done**.",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [
                    "To do"
                ],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749182733466,
                "name": "Invite your team to collaborate",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181047631,
                "id": 6026392441847808,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6169622554738688": {
                "colorIds": [
                    6289029020909568
                ],
                "orderNumber": 458752,
                "listViewOrderNumber": 1749181049,
                "created": 1749181049,
                "description": "Click **Add board** on the left-side panel to create a board for your workflow. Good luck!\n ![Add](https://www.kanbanchi.com/wp-content/uploads/2015/09/add-board-kanbanchi.jpg)",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749182734497,
                "name": "**You are ready to move forward!** 👍",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181050127,
                "id": 6169622554738688,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6751499657281536": {
                "colorIds": [],
                "orderNumber": 131072,
                "listViewOrderNumber": 1749181046,
                "created": 1749181046,
                "description": "Click ![Plus button](https://www.kanbanchi.com/wp-content/uploads/2023/02/plus-button-kanbanchi.jpg) in the Doing list, type the title of a card and hit **Enter**. ",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [
                    "To do"
                ],
                "processingPercent": 0,
                "copiedFromId": 6736137581363200,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181047152,
                "name": "Create a new card in the Doing list",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181046908,
                "id": 6751499657281536,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6249177462210560": {
                "colorIds": [
                    6007554044198912,
                    4846805678686208,
                    4600179160645632
                ],
                "orderNumber": 0,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "Kanbanchi seamlessly integrates with Google Workspace. Scroll down to the **Checklists** section to learn more.",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "13529517536500880352",
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi",
                            "lastName": "App",
                            "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s64"
                        },
                        "roleIds": []
                    }
                ],
                "tags": [
                    "Explore"
                ],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 9,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "priority": "4",
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "meta": {
                    "pinnedSections": {
                        "checklists": [
                            4569376057851904,
                            6586629989203968
                        ]
                    }
                },
                "lastActivityDateStamp": 1749182153625,
                "name": "Learn how Kanbanchi is integrated with Google Workspace and\nMicrosoft 365",
                "listId": 6386003879526400,
                "cardNumber": "",
                "moveInListDate": 1749182153625,
                "id": 6249177462210560,
                "receiveProperty": [],
                "subCardIds": [
                    6018980100046848
                ],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [
                    {
                        "id": 4569376057851904,
                        "cardId": 6249177462210560,
                        "name": "Google Workspace",
                        "checkItems": {
                            "4753762627747840": {
                                "name": "Kanbanchi boards can be **exported to Google Sheets**",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 4,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 4569376057851904,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 4753762627747840,
                                "receiveProperty": []
                            },
                            "4841802578657280": {
                                "name": "All your data is stored in **Google Drive**",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 0,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 4569376057851904,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 4841802578657280,
                                "receiveProperty": []
                            },
                            "5311813231443968": {
                                "name": "The **sharing** process is done by Google",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 2,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 4569376057851904,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 5311813231443968,
                                "receiveProperty": []
                            },
                            "6366470368264192": {
                                "name": "You can **attach files** from Google Drive",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 3,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 4569376057851904,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 6366470368264192,
                                "receiveProperty": []
                            },
                            "6598947619864576": {
                                "name": "You may add card dates to **Google Calendar**",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 1,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 4569376057851904,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 6598947619864576,
                                "receiveProperty": []
                            }
                        }
                    },
                    {
                        "id": 6586629989203968,
                        "cardId": 6249177462210560,
                        "name": "Microsoft 365",
                        "checkItems": {
                            "6335884261982208": {
                                "name": "All your data is stored in **OneDrive/SharePoint**",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 0,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 6586629989203968,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 6335884261982208,
                                "receiveProperty": []
                            },
                            "5120379224195072": {
                                "name": "**Sharing** Kanbanchi boards is like sharing files in OneDrive",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 2,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 6586629989203968,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 5120379224195072,
                                "receiveProperty": []
                            },
                            "5001159991754752": {
                                "name": "You can **attach files** from OneDrive",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 1,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 6586629989203968,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 5001159991754752,
                                "receiveProperty": []
                            },
                            "5890477530677248": {
                                "name": "Kanbanchi boards can even be used with **personal Microsoft accounts**",
                                "checked": false,
                                "weight": 1,
                                "orderNumber": 3,
                                "assignUsers": [],
                                "assignees": [],
                                "checklistId": 6586629989203968,
                                "author": {
                                    "fullName": "Kanbanchi App Team",
                                    "firstName": "Kanbanchi App",
                                    "lastName": "Team",
                                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                    "initials": "KT",
                                    "permissionId": "13529517536500880352",
                                    "hash": "e5f254cc1767c6623507723ac069558f"
                                },
                                "id": 5890477530677248,
                                "receiveProperty": []
                            }
                        }
                    }
                ],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true
            },
            "5695275964694528": {
                "colorIds": [
                    4600179160645632,
                    5163129114066944
                ],
                "orderNumber": 49152,
                "listViewOrderNumber": 1749181045,
                "created": 1749181045,
                "description": "Kanbanchi makes the work process transparent, which leads to effortless team collaboration. \nNo need to constantly refresh the page to see the latest updates - all the **changes are done in real-time**.\n**Activity** shows all the events performed, allowing you to monitor the updates.\n**Assign** cards to the team; no task will remain without attention. You may also set **roles** on your boards to display responsibilities.",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "fullName": "Friend",
                            "firstName": "Friend",
                            "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar2.png",
                            "permissionId": "04196864541585468061"
                        },
                        "roleIds": []
                    },
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "10502799560592998522",
                            "fullName": "Demo Kanbanchi",
                            "firstName": "Demo",
                            "lastName": "Kanbanchi",
                            "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar1.png",
                            "email": "demo@kanbanchi.com"
                        },
                        "roleIds": []
                    }
                ],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 5931656518172672,
                "commentCount": 1,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181046267,
                "name": "Team collaboration with Kanbanchi",
                "listId": 6451097531449344,
                "cardNumber": "",
                "moveInListDate": 1749181046103,
                "id": 5695275964694528,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [
                    {
                        "id": 6039027497435136,
                        "cardId": 5695275964694528,
                        "text": "Email us to let us know your experience of team collaboration with Kanbanchi\nteam@kanbanchi.com",
                        "created": 1718866220,
                        "author": {
                            "fullName": "Kanbanchi App Team",
                            "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                            "initials": "KA",
                            "permissionId": "13529517536500880352",
                            "hash": "e5f254cc1767c6623507723ac069558f"
                        },
                        "edited": 1718866220622,
                        "editor": {
                            "fullName": "Kanbanchi App Team",
                            "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                            "initials": "KA"
                        },
                        "timeTracker": false,
                        "driveDocIds": [],
                        "meta": {
                            "replyText": ""
                        }
                    }
                ],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6018980100046848": {
                "colorIds": [
                    6007554044198912,
                    4846805678686208
                ],
                "orderNumber": 65536,
                "listViewOrderNumber": 1749181046,
                "created": 1749181046,
                "description": "[Install Kanbanchi Gmail add-on](https://workspace.google.com/marketplace/app/email_to_task_on_a_kanban_board/590990492974) from Google Workspace Marketplace to convert emails from Gmail into Kanbanchi cards.\n\nUse the **board email address** to send information from Outlook to your Kanbanchi boards.",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "13529517536500880352",
                            "fullName": "Kanbanchi App Team",
                            "firstName": "Kanbanchi",
                            "lastName": "App",
                            "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s64"
                        },
                        "roleIds": []
                    }
                ],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "priority": "3",
                "recurringTasks": [],
                "epicId": 6249177462210560,
                "subCardOrderNumber": 0,
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749182268419,
                "name": "**Create cards via email**",
                "listId": 6451097531449344,
                "cardNumber": "",
                "moveInListDate": 1749181046737,
                "id": 6018980100046848,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6043041278590976": {
                "colorIds": [
                    4600179160645632,
                    5163129114066944
                ],
                "orderNumber": 32768,
                "listViewOrderNumber": 1749181045,
                "created": 1749181045,
                "description": "Kanbanchi gives plenty of features for task configuration and management. \nConfigure tasks with **card properties**. Create custom properties to add more information to cards.\n**Subcards** make it easier to handle complex tasks and provide an opportunity to depict various workflow aspects on the same board. \n**Search & Filter** allows you to focus on specific cards even if your board is going to have numerous items. Don't be afraid to build a sophisticated work process. \n**Templates** and **Recurring cards** automate the process and help save time.",
                "assignedToDetails": [],
                "assignees": [
                    {
                        "sharedUser": {
                            "role": "owner",
                            "permissionId": "10502799560592998522",
                            "fullName": "Demo Kanbanchi",
                            "firstName": "Demo",
                            "lastName": "Kanbanchi",
                            "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar1.png",
                            "email": "demo@kanbanchi.com"
                        },
                        "roleIds": []
                    }
                ],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 5348511360090112,
                "commentCount": 1,
                "relatedCardCount": 0,
                "status": 0,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181045641,
                "name": "Task management with Kanbanchi",
                "listId": 6451097531449344,
                "cardNumber": "",
                "moveInListDate": 1749181045444,
                "id": 6043041278590976,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [
                    {
                        "id": 4787832992694272,
                        "cardId": 6043041278590976,
                        "text": "Email us to let us know your experience of task management with Kanbanchi\nteam@kanbanchi.com",
                        "created": 1718866191,
                        "author": {
                            "fullName": "Kanbanchi App Team",
                            "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                            "initials": "KA",
                            "permissionId": "13529517536500880352",
                            "hash": "e5f254cc1767c6623507723ac069558f"
                        },
                        "edited": 1718866191299,
                        "editor": {
                            "fullName": "Kanbanchi App Team",
                            "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                            "initials": "KA"
                        },
                        "timeTracker": false,
                        "driveDocIds": [],
                        "meta": {
                            "replyText": ""
                        }
                    }
                ],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "5119365209260032": {
                "colorIds": [],
                "orderNumber": 65536,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 30,
                "templateId": 6118900583497728,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [
                    {
                        "id": 5564939721113600,
                        "startDate": 4102462800000,
                        "listId": 5653237059682304,
                        "cardId": 5119365209260032,
                        "endType": "never",
                        "frequencyType": "year",
                        "year": {
                            "yearCount": 100
                        },
                        "status": "not_processed"
                    }
                ],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181044977,
                "name": "Automate your process with recurring cards",
                "listId": 6551539301089280,
                "cardNumber": "",
                "moveInListDate": 1749181044828,
                "id": 5119365209260032,
                "receiveProperty": []
            },
            "6676222403018752": {
                "colorIds": [],
                "orderNumber": 0,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 30,
                "templateId": 5048178725486592,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181044465,
                "name": "Save time with card templates",
                "listId": 6551539301089280,
                "cardNumber": "",
                "moveInListDate": 1749181044314,
                "id": 6676222403018752,
                "receiveProperty": []
            },
            "4688708905598976": {
                "colorIds": [
                    5163129114066944
                ],
                "orderNumber": -65536,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "Click ![archive icon](https://www.kanbanchi.com/wp-content/uploads/2023/02/archive-icon.jpg) to send the card to the archive/unarchive a card.",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 5085530533003264,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 2,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181045148,
                "name": "This card is in the Archive 💾",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181045002,
                "id": 4688708905598976,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLkAsibu4s-zNEepYLIna-jK-2s0HXxyY_8ql24yTBKTw=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "4930591665815552": {
                "colorIds": [
                    4600179160645632
                ],
                "orderNumber": -65536,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "Review [this article](https://www.kanbanchi.com/blog/what-is-a-kanban-board) to learn more about Kanban.",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 4894785398243328,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 2,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181044542,
                "name": "Explore Kanban",
                "listId": 6371295495585792,
                "cardNumber": "",
                "moveInListDate": 1749181044375,
                "id": 4930591665815552,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLkAsibu4s-zNEepYLIna-jK-2s0HXxyY_8ql24yTBKTw=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "6101307241136128": {
                "colorIds": [],
                "orderNumber": -65536,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "",
                "assignedToDetails": [],
                "assignees": [],
                "doneDate": 1706615713,
                "tags": [],
                "processingStatus": "done",
                "processingPercent": 100,
                "copiedFromId": 5551446437789696,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 2,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181044588,
                "name": "Sign up to Kanbanchi",
                "listId": 6313432756649984,
                "cardNumber": "",
                "moveInListDate": 1749181044414,
                "id": 6101307241136128,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLkAsibu4s-zNEepYLIna-jK-2s0HXxyY_8ql24yTBKTw=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            },
            "5796159075778560": {
                "colorIds": [],
                "orderNumber": -65536,
                "listViewOrderNumber": 1749181044,
                "created": 1749181044,
                "description": "",
                "assignedToDetails": [],
                "assignees": [],
                "tags": [],
                "processingPercent": 0,
                "copiedFromId": 5554985222406144,
                "commentCount": 0,
                "relatedCardCount": 0,
                "status": 2,
                "checklistStats": {
                    "totalCount": 0,
                    "checkedCount": 0,
                    "checkedPercent": 0,
                    "estimate": 0
                },
                "recurringTasks": [],
                "ganttVisibility": false,
                "isMilestone": false,
                "lastActivityDateStamp": 1749181044522,
                "name": "[What is Kanbanchi?](https://www.kanbanchi.com/faqwd/what-is-kanbanchi)",
                "listId": 5173349257183232,
                "cardNumber": "",
                "moveInListDate": 1749181044370,
                "id": 5796159075778560,
                "receiveProperty": [],
                "driveDocs": [],
                "comments": [],
                "author": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLkAsibu4s-zNEepYLIna-jK-2s0HXxyY_8ql24yTBKTw=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "calendarEvents": [],
                "notificationBeforeDueDates": [],
                "relatedCards": [],
                "customFields": [],
                "successors": [],
                "inWorkUsers": [],
                "checklists": [],
                "chatId": 0,
                "wtch": false,
                "mainDriveDocSet": [],
                "predecessors": [],
                "isFullLoaded": true,
                "meta": {}
            }
        },
        "checklists": {
            "6249177462210560": {
                "4569376057851904": {
                    "id": 4569376057851904,
                    "cardId": 6249177462210560,
                    "name": "Google Workspace",
                    "checkItems": {
                        "4753762627747840": {
                            "name": "Kanbanchi boards can be **exported to Google Sheets**",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 4,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 4569376057851904,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 4753762627747840,
                            "receiveProperty": []
                        },
                        "4841802578657280": {
                            "name": "All your data is stored in **Google Drive**",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 0,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 4569376057851904,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 4841802578657280,
                            "receiveProperty": []
                        },
                        "5311813231443968": {
                            "name": "The **sharing** process is done by Google",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 2,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 4569376057851904,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 5311813231443968,
                            "receiveProperty": []
                        },
                        "6366470368264192": {
                            "name": "You can **attach files** from Google Drive",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 3,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 4569376057851904,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 6366470368264192,
                            "receiveProperty": []
                        },
                        "6598947619864576": {
                            "name": "You may add card dates to **Google Calendar**",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 1,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 4569376057851904,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/AGNmyxZYj0kC-Jp-yfZeDZ3iXDuP6ekVUU5gfWyVwxun=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 6598947619864576,
                            "receiveProperty": []
                        }
                    }
                },
                "6586629989203968": {
                    "id": 6586629989203968,
                    "cardId": 6249177462210560,
                    "name": "Microsoft 365",
                    "checkItems": {
                        "6335884261982208": {
                            "name": "All your data is stored in **OneDrive/SharePoint**",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 0,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 6586629989203968,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 6335884261982208,
                            "receiveProperty": []
                        },
                        "5120379224195072": {
                            "name": "**Sharing** Kanbanchi boards is like sharing files in OneDrive",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 2,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 6586629989203968,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 5120379224195072,
                            "receiveProperty": []
                        },
                        "5001159991754752": {
                            "name": "You can **attach files** from OneDrive",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 1,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 6586629989203968,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 5001159991754752,
                            "receiveProperty": []
                        },
                        "5890477530677248": {
                            "name": "Kanbanchi boards can even be used with **personal Microsoft accounts**",
                            "checked": false,
                            "weight": 1,
                            "orderNumber": 3,
                            "assignUsers": [],
                            "assignees": [],
                            "checklistId": 6586629989203968,
                            "author": {
                                "fullName": "Kanbanchi App Team",
                                "firstName": "Kanbanchi App",
                                "lastName": "Team",
                                "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIsrg9pb6xjzly216BnFdGGXloHYdUG-N1iKJHtZ70JUy5gcWvs=s96-c",
                                "initials": "KT",
                                "permissionId": "13529517536500880352",
                                "hash": "e5f254cc1767c6623507723ac069558f"
                            },
                            "id": 5890477530677248,
                            "receiveProperty": []
                        }
                    }
                }
            },
            "4635528821866496": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4635528821866496
                }
            },
            "6145517654769664": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6145517654769664
                }
            },
            "6081590354903040": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6081590354903040
                }
            },
            "4636306479382528": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4636306479382528
                }
            },
            "4606990710341632": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4606990710341632
                }
            },
            "4556416530907136": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4556416530907136
                }
            },
            "4541511786430464": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4541511786430464
                }
            },
            "6260763572699136": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6260763572699136
                }
            },
            "6299249164025856": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6299249164025856
                }
            },
            "5985933715701760": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 5985933715701760
                }
            },
            "4706068190330880": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4706068190330880
                }
            },
            "5287497181822976": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 5287497181822976
                }
            },
            "5902303790235648": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 5902303790235648
                }
            },
            "6751499657281536": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6751499657281536
                }
            },
            "6169622554738688": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6169622554738688
                }
            },
            "6026392441847808": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6026392441847808
                }
            },
            "5695275964694528": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 5695275964694528
                }
            },
            "6043041278590976": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6043041278590976
                }
            },
            "6018980100046848": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6018980100046848
                }
            },
            "4688708905598976": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4688708905598976
                }
            },
            "4930591665815552": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 4930591665815552
                }
            },
            "6101307241136128": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 6101307241136128
                }
            },
            "5796159075778560": {
                "0": {
                    "id": 0,
                    "name": "Checklist",
                    "cardId": 5796159075778560
                }
            }
        },
        "dashboards": {
            "5850447135244288": {
                "fileId": "16hKOfFHdV-WzZYTEfLvexa1aJp8-xYMy",
                "platformType": "google",
                "colors": [
                    {
                        "id": 4565330701975552,
                        "color": "vivid-red",
                        "name": "Red",
                        "status": 1,
                        "orderNumber": 0
                    },
                    {
                        "id": 4600179160645632,
                        "color": "vivid-green",
                        "name": "Info",
                        "status": 0,
                        "orderNumber": 3
                    },
                    {
                        "id": 4846805678686208,
                        "color": "pastel-red",
                        "name": "Microsoft",
                        "status": 0,
                        "orderNumber": 10
                    },
                    {
                        "id": 4881654137356288,
                        "color": "pastel-orange",
                        "name": "Orange pastel",
                        "status": 1,
                        "orderNumber": 11
                    },
                    {
                        "id": 4952022881533952,
                        "color": "vivid-light-grey",
                        "name": "Light grey",
                        "status": 1,
                        "orderNumber": 8
                    },
                    {
                        "id": 5128280655396864,
                        "color": "pastel-brown",
                        "name": "Brown pastel",
                        "status": 1,
                        "orderNumber": 17
                    },
                    {
                        "id": 5163129114066944,
                        "color": "vivid-orange",
                        "name": "Features",
                        "status": 0,
                        "orderNumber": 1
                    },
                    {
                        "id": 5409755632107520,
                        "color": "vivid-yellow",
                        "name": "FAQ",
                        "status": 0,
                        "orderNumber": 2
                    },
                    {
                        "id": 5514972834955264,
                        "color": "pastel-yellow",
                        "name": "Yellow pastel",
                        "status": 1,
                        "orderNumber": 12
                    },
                    {
                        "id": 5585677492551680,
                        "color": "pastel-blue",
                        "name": "Blue pastel",
                        "status": 1,
                        "orderNumber": 14
                    },
                    {
                        "id": 5691230608818176,
                        "color": "pastel-light-grey",
                        "name": "Light grey pastel",
                        "status": 1,
                        "orderNumber": 18
                    },
                    {
                        "id": 5726079067488256,
                        "color": "vivid-grey",
                        "name": "Grey",
                        "status": 1,
                        "orderNumber": 9
                    },
                    {
                        "id": 5972705585528832,
                        "color": "vivid-purple",
                        "name": "Purple",
                        "status": 1,
                        "orderNumber": 5
                    },
                    {
                        "id": 6007554044198912,
                        "color": "vivid-blue",
                        "name": "Google",
                        "status": 0,
                        "orderNumber": 4
                    },
                    {
                        "id": 6077922788376576,
                        "color": "vivid-brown",
                        "name": "Brown",
                        "status": 1,
                        "orderNumber": 7
                    },
                    {
                        "id": 6254180562239488,
                        "color": "vivid-pink",
                        "name": "Pink",
                        "status": 1,
                        "orderNumber": 6
                    },
                    {
                        "id": 6289029020909568,
                        "color": "pastel-purple",
                        "name": "Real App",
                        "status": 0,
                        "orderNumber": 15
                    },
                    {
                        "id": 6535655538950144,
                        "color": "pastel-green",
                        "name": "Green pastel",
                        "status": 1,
                        "orderNumber": 13
                    },
                    {
                        "id": 6640872741797888,
                        "color": "pastel-pink",
                        "name": "Pink pastel",
                        "status": 1,
                        "orderNumber": 16
                    },
                    {
                        "id": 6711577399394304,
                        "color": "pastel-grey",
                        "name": "Grey pastel",
                        "status": 1,
                        "orderNumber": 19
                    }
                ],
                "users": [
                    {
                        "role": "owner",
                        "permissionId": "10502799560592998522",
                        "fullName": "Demo Kanbanchi",
                        "firstName": "Demo",
                        "lastName": "Kanbanchi",
                        "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar1.png",
                        "email": "demo@kanbanchi.com"
                    },
                    {
                        "fullName": "Friend",
                        "firstName": "Friend",
                        "photoUrl": "https://www.kanbanchi.com/wp-content/uploads/img/avatar2.png",
                        "permissionId": "04196864541585468061"
                    }
                ],
                "copiedFromId": 5719466544594944,
                "template": false,
                "logoColor": "#dbd3fd",
                "logoIcon": "start-date",
                "cometToken": "",
                "cardFromEmail": "",
                "version": 11,
                "enableOpenGraphInfo": false,
                "cardNumberEnabled": false,
                "showOnGantt": false,
                "driveId": "DRIVE_ID_SHARED_WITH_ME",
                "driveType": "SHARED_WITH_ME",
                "statusLists": {
                    "doneId": 4946132065452032
                },
                "archiveCardsOnDelete": false,
                "assetFolderId": "1aDiStLzCnWcprFYuiLPWz6cvxouKx2YN",
                "meta": {
                    "cardDefaultProperties": [
                        "CARD_ASSIGNEES",
                        "CARD_COMMENTS",
                        "CARD_START_DATE",
                        "CARD_DUE_DATE"
                    ],
                    "isMyTasksDone": true,
                    "cardsActiveCount": 20,
                    "cardCustomProperties": {}
                },
                "cardAssigneeRoles": [
                    {
                        "id": 4938650903511040,
                        "color": "green",
                        "name": "Admin",
                        "status": 0
                    },
                    {
                        "id": 5483063039885312,
                        "color": "red",
                        "name": "Lead",
                        "status": 0
                    },
                    {
                        "id": 6616177350934528,
                        "color": "blue",
                        "name": "Manager",
                        "status": 0
                    }
                ],
                "allowReports": true,
                "backupFolderInfo": {
                    "folderId": "15yj4upuiBAxg7ClFj1IbPddTVDA1iv0b"
                },
                "id": 5850447135244288,
                "name": "Demo Info Board",
                "author": {},
                "description": "",
                "created": 1749181042,
                "permissions": {
                    "authPermissions": {
                        "allowView": true,
                        "allowEdit": true,
                        "allowComment": true,
                        "allowChangeTimeZone": false,
                        "allowCreateBackUp": false,
                        "allowViewBackUp": true,
                        "allowChangeLogo": false,
                        "allowSendReportStatistics": true,
                        "allowMoveThisBoard": false,
                        "allowDelete": false,
                        "allowArchive": false,
                        "allowChangeBackground": true,
                        "allowShare": true,
                        "allowEnableOpenGraphInfo": false,
                        "allowChangeCardNumber": false,
                        "allowUnlimitedCards": true,
                        "allowEditCardDetailSettings": false,
                        "allowEditPublicFilters": false
                    },
                    "publicPermissions": {
                        "type": "anyoneWithLink",
                        "access": "view",
                        "accessType": 1
                    }
                },
                "shared": true,
                "starred": false,
                "theme": {
                    "id": 5120565370159104,
                    "libraryCssClass": "theme-16",
                    "jsonRest": false
                },
                "timeZone": "Asia/Bangkok",
                "workHoursInDay": 8,
                "hash": "cdfe08416cb6e681380814bc023bd0aa",
                "status": 0,
                "lastUpdatePermissionTime": 1749181042,
                "parentFolderInfo": {
                    "folderId": "1BYEDpYYXOD9OkZ5cMkShPa3JCJDdz5lG"
                },
                "forDashboard": false,
                "noCards": false,
                "listIds": [
                    4946132065452032,
                    5173349257183232,
                    5653237059682304,
                    6313432756649984,
                    6371295495585792,
                    6386003879526400,
                    6451097531449344,
                    6551539301089280
                ],
                "closed": false
            }
        },
        "dependencies": {
            "5558009682329600": {
                "id": 5558009682329600,
                "type": "FTS",
                "predecessorId": 4706068190330880,
                "successorId": 4556416530907136
            },
            "5228937542500352": {
                "id": 5228937542500352,
                "type": "FTS",
                "predecessorId": 4606990710341632,
                "successorId": 4706068190330880
            }
        },
        "driveDocs": {
            "5403218322784256": {
                "title": "Kanbanchi plans comparison.pdf",
                "fileId": "1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                "mimeType": "application/pdf",
                "url": "https://drive.google.com/file/d/1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T/view?usp=drivesdk",
                "iconUrl": "https://drive-thirdparty.googleusercontent.com/32/type/application/pdf",
                "thumbUrl": "https://drive.google.com/thumbnail?authuser=0&sz=w280&id=1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                "bigThumbUrl": "https://drive.google.com/thumbnail?authuser=0&sz=w600&id=1o1vXpVqqHiqt7rsp-TlURTYW9Ki2gq2T",
                "main": true,
                "orderNumber": 0,
                "created": 1727349240,
                "authorDetails": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "isImage": false,
                "cardId": 6260763572699136,
                "type": "card",
                "platformType": "google",
                "id": 5403218322784256,
                "receiveProperty": []
            },
            "4567940196597760": {
                "title": "Kanbanchi for Enterprise.pdf",
                "fileId": "1fmLbRq9kt32nSKvnLzYge3TgUpjRuhcp",
                "mimeType": "application/pdf",
                "url": "https://drive.google.com/file/d/1fmLbRq9kt32nSKvnLzYge3TgUpjRuhcp/view?usp=drivesdk",
                "iconUrl": "https://drive-thirdparty.googleusercontent.com/32/type/application/pdf",
                "main": false,
                "orderNumber": 1,
                "created": 1727351015,
                "authorDetails": {
                    "fullName": "Kanbanchi App Team",
                    "firstName": "Kanbanchi App",
                    "lastName": "Team",
                    "photoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJhZscD9VP2KbeKfhpqpkCivoBUAwYxgT7s34b4smv1Cvrih6Y=s96-c",
                    "initials": "KT",
                    "permissionId": "13529517536500880352",
                    "hash": "e5f254cc1767c6623507723ac069558f"
                },
                "isImage": false,
                "cardId": 6260763572699136,
                "type": "card",
                "platformType": "google",
                "id": 4567940196597760,
                "receiveProperty": []
            }
        },
        "lists": {
            "4946132065452032": {
                "id": 4946132065452032,
                "name": "Done",
                "orderNumber": 5,
                "cardAutoIncrement": 0,
                "cardAutoDecrement": 0,
                "status": 0,
                "sorting": {
                    "sortField": "Sort by priority",
                    "isDesc": true,
                    "isEnabled": false
                },
                "dashboardId": 5850447135244288,
                "cardIds": [
                    4606990710341632
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "5173349257183232": {
                "id": 5173349257183232,
                "name": "FAQs",
                "description": "In this list, you will find cards with the most frequently asked questions. You may find more questions and answers on [Kanbanchi website](https://www.kanbanchi.com/kanbanchi-faq).",
                "orderNumber": 6,
                "copiedFromId": 5476658822905856,
                "cardAutoIncrement": 131072,
                "cardAutoDecrement": -65536,
                "status": 0,
                "sorting": {
                    "sortField": "Sort by priority",
                    "isDesc": true,
                    "isEnabled": false
                },
                "dashboardId": 5850447135244288,
                "cardIds": [
                    4635528821866496,
                    4636306479382528,
                    6299249164025856,
                    5796159075778560
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "5653237059682304": {
                "id": 5653237059682304,
                "name": "General info",
                "orderNumber": 0,
                "copiedFromId": 5977827886366720,
                "cardAutoIncrement": 3145728,
                "cardAutoDecrement": -65536,
                "maxCardNumber": 0,
                "status": 0,
                "dashboardId": 5850447135244288,
                "cardIds": [
                    5985933715701760,
                    6081590354903040,
                    6145517654769664
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "6313432756649984": {
                "id": 6313432756649984,
                "name": "To Do",
                "orderNumber": 4,
                "copiedFromId": 6326502122717184,
                "cardAutoIncrement": 131072,
                "cardAutoDecrement": -65536,
                "maxCardNumber": 0,
                "status": 0,
                "sorting": {
                    "sortField": "Sort by priority",
                    "isDesc": true,
                    "isEnabled": true
                },
                "dashboardId": 5850447135244288,
                "cardIds": [
                    6260763572699136,
                    6101307241136128
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "6371295495585792": {
                "id": 6371295495585792,
                "name": "Simple steps to start",
                "orderNumber": 3,
                "copiedFromId": 6038269484728320,
                "cardAutoIncrement": 524288,
                "cardAutoDecrement": -65536,
                "status": 0,
                "sorting": {
                    "sortField": "Sort by priority",
                    "isDesc": true,
                    "isEnabled": false
                },
                "dashboardId": 5850447135244288,
                "cardIds": [
                    4541511786430464,
                    4556416530907136,
                    4706068190330880,
                    5287497181822976,
                    5902303790235648,
                    6026392441847808,
                    6169622554738688,
                    6751499657281536,
                    4688708905598976,
                    4930591665815552
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "6386003879526400": {
                "id": 6386003879526400,
                "name": "Integrations",
                "orderNumber": 1,
                "cardAutoIncrement": 0,
                "cardAutoDecrement": 0,
                "status": 0,
                "sorting": {
                    "sortField": "Sort by priority",
                    "isDesc": true,
                    "isEnabled": false
                },
                "dashboardId": 5850447135244288,
                "cardIds": [
                    6249177462210560
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "6451097531449344": {
                "id": 6451097531449344,
                "name": "Opportunities",
                "orderNumber": 2,
                "copiedFromId": 6753602596110336,
                "cardAutoIncrement": 393216,
                "cardAutoDecrement": -65536,
                "maxCardNumber": 0,
                "status": 0,
                "dashboardId": 5850447135244288,
                "cardIds": [
                    5695275964694528,
                    6018980100046848,
                    6043041278590976
                ],
                "archiveLoaded": true,
                "meta": {}
            },
            "6551539301089280": {
                "id": 6551539301089280,
                "name": "Templates list",
                "orderNumber": 0,
                "copiedFromId": 5112141861486592,
                "cardAutoIncrement": 65536,
                "cardAutoDecrement": 0,
                "status": 30,
                "dashboardId": 5850447135244288,
                "cardIds": [
                    5119365209260032,
                    6676222403018752
                ],
                "archiveLoaded": true,
                "meta": {}
            }
        },
        "tabs": {
            "5850447135244288": {
                "driveId": "DRIVE_ID_SHARED_WITH_ME",
                "id": 5850447135244288,
                "isShared": true,
                "logoColor": "#dbd3fd",
                "name": "Demo Info Board",
                "starred": false,
                "status": 0
            }
        },
        "notificationsSettings": {},
        "pushNotificationsSettings": {
            "5850447135244288": {
                "enabled": true,
                "scope": [
                    "watch",
                    "mention",
                    "eventAssignedMe"
                ],
                "types": [
                    "nameChanged",
                    "descChanged",
                    "userAssigned",
                    "priorityChanged",
                    "commentAdded",
                    "attachAdded",
                    "deleted",
                    "archived",
                    "done",
                    "overdue"
                ],
                "subscribeCases": [
                    "cardCreate",
                    "commentMention",
                    "assign",
                    "commentAdd"
                ],
                "id": "5850447135244288-109904642684951714227",
                "dashboardId": 5850447135244288
            }
        },
        "libThemes": {},
        "backups": {},
        "cardAssignees": {},
        "boardUserActivityTimes": {},
        "boardUserMetas": {
            "5850447135244288": {
                "foldedLists": [],
                "recentCards": [
                    6081590354903040,
                    6145517654769664
                ]
            }
        },
        "products": [
        ]
    }
}
